import { Component, OnInit } from '@angular/core';
import { NgIf } from '@angular/common';
import { Router } from '@angular/router';
import { RegisterService } from './register.service';
import { Register } from './Register';

@Component({
    selector: 'register',
    providers: [RegisterService],
    template: require('./register.component.html')
})

export class RegisterComponent implements OnInit {

    error: boolean = false;
    code: number = 0;
    isProfesional: boolean = false;
    preserveDNI: string = "";
    formNif: string = "";
    errorCodes: number[] = [];
    model = new Register("", "", "", "");
    language: string;
    passwordType: string;

    constructor(private _registerService: RegisterService, public router: Router) {
        this.passwordType = "password";

        var hostname = location.host;        
        if (hostname == "www.mercadilloambulante.com" || hostname == "www.mercadilloambulante.eu" || hostname == "mercadilloambulante.com" || hostname == "mercadilloambulante.eu") {
            this.language = "ES";
        }
        else if (hostname == "www.mercatambulant.cat" || hostname == "mercatambulant.cat" || hostname == "localhost") {
            this.language = "CAT";
        }
        else {
            this.language = "ES";
        }

    }

    ngOnInit() {
        this._registerService.getUserStatus().then((data: any) => {            
            if (data.role != "guest") {
                this.router.navigate(['/main', 'dashboard']);
            }
        });
    }

    changeProfesional($event: any, profesional: boolean) {
        this.isProfesional = profesional;
        if (!this.isProfesional) {
            this.preserveDNI = this.model.nif;
            this.formNif = "";
        }
        else {
            this.formNif = this.preserveDNI;
            this.preserveDNI = "";
        }
    }

    onSubmit(value: any) {
        if (this.checkParams(value)) {
            this._registerService.existsEmail(value.email).then(
                res => {                    
                    if (res) {
                        this.errorCodes.push(534);
                    }
                    else {
                        value.profesional = this.isProfesional;
                        value.language = this.language;
                        this._registerService.register(value)
                            .subscribe(
                            (result) => {                                
                                this.code = result.code;
                                if (result !== null && result.token !== undefined) {
                                    //location.reload();

                                    if (value.profesional) {
                                        localStorage.setItem("userRole", "superuser");
                                        this.router.navigate(['/superuser', 'start']);
                                    }
                                    else {
                                        localStorage.setItem("userRole", "user");
                                        this.router.navigate(['/main', 'dashboard'])
                                    }
                                }
                            },
                            () => { this.error = true; }
                            );
                    }
                });
        }
    }

    codeError(code: any) {
        var found = false;
        var i = 0;

        while (!found && i < this.errorCodes.length) {
            if (code == this.errorCodes[i]) {
                found = true;
            }
            i++;
        }
        return found;
    }

    private checkParams(value: any) {
        this.errorCodes = [];
        //email check
        if (value.email.length === 0) {
            this.errorCodes.push(531);
        }
        else if (value.email.length > 50) {
            this.errorCodes.push(53);
        }
        else if (!this.validateEmail(value.email)) {
            this.errorCodes.push(533);
        }

        //password check
        if (value.password.length === 0) {
            this.errorCodes.push(535);
        }
        else if (value.password.length < 4) {
            this.errorCodes.push(536);
        }
        else if (value.password.length > 40) {
            this.errorCodes.push(537);
        }

        //name check
        if (value.name.length === 0) {
            this.errorCodes.push(538);
        }
        else if (value.name.length < 2) {
            this.errorCodes.push(539);
        }
        else if (value.name.length > 60) {
            this.errorCodes.push(540);
        }

        if (this.isProfesional) {
            //nif check
            if (value.nif === 0) {
                this.errorCodes.push(541);
            }
            else if (!this.validateNIF(value.nif)) {
                this.errorCodes.push(542);
            }
        }
        if (this.errorCodes.length > 0) {
            this._registerService.existsEmail(value.email).then(
                res => {
                    if (res) {
                        this.errorCodes.push(534);
                    }
                });
        }
        return this.errorCodes.length === 0;
    }

    private validateEmail(email: string) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

    private validateNIF(value: string) {

        var validChars = 'TRWAGMYFPDXBNJZSQVHLCKET';
        var nifRexp = /^[0-9]{8}(-?)[TRWAGMYFPDXBNJZSQVHLCKET]{1}$/i;
        var nieRexp = /^[XYZ]{1}[0-9]{7}(-?)[TRWAGMYFPDXBNJZSQVHLCKET]{1}$/i;
        var str = value.toString().toUpperCase();

        if (!nifRexp.test(str) && !nieRexp.test(str)) return false;

        var nie = str
            .replace(/^[X]/, '0')
            .replace(/^[Y]/, '1')
            .replace(/^[Z]/, '2');

        var letter = str.substr(-1);
        var charIndex = parseInt(nie.substr(0, 8)) % 23;

        if (validChars.charAt(charIndex) === letter) return true;

        return false;
    }

    onChangePassword(flag: any) {
        if (!flag) {
            this.passwordType = "password";
        } else {
            this.passwordType = "text";
        }
    }
}




/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/register/register.component.ts
 **/